import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { api } from "../../api/api";
import { CountriesState, Country } from "./types";

const initialState: CountriesState = {
  data: [],
  loading: false,
  error: null,
  mainCountriesForRegions: [],
};

export const fetchAllCountriesDataAsync = createAsyncThunk(
  "countriesAll/fetchCountriesAllData",
  async () => await api.getAllCountries()
);

const countriesAllSlice = createSlice({
  name: "countriesAll",
  initialState,
  reducers: {
    setMainCountriesForRegions: (state, action: PayloadAction<Country[]>) => {
      state.mainCountriesForRegions = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllCountriesDataAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllCountriesDataAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchAllCountriesDataAsync.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message ?? "Failed to fetch all countries data";
      });
  },
});

export const { setMainCountriesForRegions } = countriesAllSlice.actions;

export default countriesAllSlice.reducer;
